"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _colors = _interopRequireDefault(require("../../constants/colors"));

var _spacing = _interopRequireDefault(require("../../constants/spacing"));

var _vars = _interopRequireDefault(require("../../constants/vars"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\tfont-weight: normal;\n\tfont-family: ", ";\n\tdisplay: flex;\n\tcolor: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tmargin: 6px ", ";\n\tdisplay: inline-flex;\n\tbackground-color: ", ";\n\tborder-radius: 14px;\n\tpadding: 2px 12px;\n\tfont-size: 14px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

// specific spacing values in here but it's such a tiny component that accurate layout needed
var PillWrapper = _styledComponents.default.div(_templateObject(), _spacing.default.s1, function (props) {
  return props.backgroundColor;
});

PillWrapper.displayName = 'Pill';

var Label = _styledComponents.default.span(_templateObject2(), _vars.default.fontStackNormal, function (props) {
  return props.color;
});

Label.displayName = 'Label';

var Pill = function Pill(_ref) {
  var children = _ref.children,
      color = _ref.color,
      rest = _objectWithoutPropertiesLoose(_ref, ["children", "color"]);

  return _react.default.createElement(PillWrapper, rest, _react.default.createElement(Label, {
    color: color
  }, children));
};

Pill.propTypes = {
  backgroundColor: _propTypes.string,
  color: _propTypes.string,
  children: _propTypes.node.isRequired
};
Pill.defaultProps = {
  backgroundColor: _colors.default.primaryDarker,
  color: _colors.default.white
};
var _default = Pill;
exports.default = _default;